/**
 * withTimeout — bound any promise. Rejects with Error('timeout:<label>')
 * after `ms`. Use everywhere a network or native bridge call could hang.
 */
export async function withTimeout<T>(p: Promise<T>, ms: number, label = 'op'): Promise<T> {
  return Promise.race<T>([
    p,
    new Promise<T>((_, rej) =>
      setTimeout(() => rej(new Error(`timeout:${label}`)), ms),
    ),
  ]);
}
